/* 孫吳傳・第 2 章：宛城先登（中平元年，184）
 * 史實：《三國志·孫堅傳》「汝、潁賊困迫，走保宛城。堅身當一面，登城先入，衆乃蟻附，遂大破之。」
 *       《後漢書·朱儁傳》：朱儁鳴鼓攻宛城西南，賊悉衆赴之；朱儁自將精卒掩其東北，乘城而入，韓忠退保小城。
 * 流程：東北待命 → 朱儁在西南擊鼓，東北的守軍一批批調去西南（任務欄看得到還剩幾人）→
 *       冒著城頭的箭雨與熱油（都先預告）到北牆架雲梯；梯腳要有少年守著，不然會被推倒 →
 *       攀城先登，東北門打開，漢軍蟻附而入 → 城中擊退韓忠（退保小城即勝利）。
 * 西南佯攻 110 秒後結束，調走的守軍會回來。
 * 招式環節：梯子架好後，城頭的弓手全盯著梯子，站著攀城一定會被射下來。要先在旁邊放 W 赤幘，
 *       替身留在原地吸住箭，自己隱身走到梯下攀城（赤幘當替身是梁東之戰的事，這裡是遊戲的借用）。
 * 這是第 1 章「西華・宛城」的第二幕（def.of）：打完西華直接接過來，等級、裝備、金錢帶著走；評星看兩幕。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, troop, PEOPLE, rout } from '../kit.ts';
import { CITY, GATES, LADDER } from '../maps/wan.ts';

const START = [7700, 1250], INSIDE = [LADDER[0], LADDER[1] + 230], NE_POST = [6800, 2500], SW_POST = [5200, 3650];
const FEINT = 110, LV = 6;
const HAN = troop('han-soldier', '漢軍', { armor: '#8a3a2a', sleeve: '#6a2a20', cloth: '#6a2a20', plume: '#d05a3a' }, SG.SOLDIERS.wu);
const NAMES = ['鄉里少年', '鄉里少年', '鄉里少年', '鄉里少年', '淮泗精兵', '淮泗精兵', '淮泗精兵', '淮泗精兵'];

export default {
  id: 'sunwu-2', of: 'sunjian-1', map: 'wan', hero: 'sunjian',
  title: '第 1 章　西華・宛城（下）', year: '中平元年（184）',
  brief: {
    quote: [{ text: '汝、潁賊困迫，走保宛城。堅身當一面，登城先入，衆乃蟻附，遂大破之。', src: '《三國志·吳書·孫堅傳》' }],
    text: '孫堅在西華墮馬重傷，養了十幾天傷又上陣。汝南、潁川的黃巾被打散，退守南陽的宛城。朱儁在西南鳴鼓佯攻，引開守軍；孫堅帶著鄉里少年與淮泗精兵，在東北伺機攻城。',
    goals: ['等朱儁在西南擊鼓', '在北牆架起雲梯；放赤幘引開城頭的箭，攀城先登', '擊退守將韓忠'],
  },
  words: { ally: '少年與精兵', foe: '黃巾' },
  stars: [ // 兩幕合算：西華一顆、宛城兩顆
    { text: '西華：重傷躲藏時沒有被黃巾兵發現', ok: (m) => !(m.prev && m.prev.vars.spotted) },
    { text: '宛城：一次就先登（雲梯沒被推倒、攀城沒被射下來）', ok: (m) => !m.vars.fell && !m.vars.shotDown },
    { text: '宛城：佯攻結束、守軍調回來之前先登', ok: (m) => m.vars.climbT != null && m.vars.climbT < FEINT },
  ],
  steps: [
    { // 1. 東北待命：城門關著，等西南的鼓聲
      enter(m, w) {
        const me = w.player;
        me.x = START[0]; me.y = START[1];
        setLevel(w, me, LV);
        m.gate('ne', GATES.ne[0], GATES.ne[1], 110, 'citygate', ['孫堅', '城門緊閉，硬撞不開。等朱將軍那邊的鼓聲。']);
        m.gate('sw', GATES.sw[0], GATES.sw[1], 110, 'citygate');
        m.vars.men = NAMES.map((n, i) => { const u = m.recruit(START[0] - 120 - (i % 4) * 50, START[1] + 80 + Math.floor(i / 4) * 60, n); m.join(u, me); return u; });
        m.vars.ne = []; m.vars.sw = [];
        for (let i = 0; i < 14; i++) m.vars.ne.push(m.foe('huangjin', NE_POST[0] - 300 + (i % 7) * 100, NE_POST[1] - 150 + Math.floor(i / 7) * 160));
        for (let i = 0; i < 8; i++) m.vars.sw.push(m.foe('huangjin', SW_POST[0] - 200 + (i % 4) * 120, SW_POST[1] - 80 + Math.floor(i / 4) * 140));
        m.obj('drum', '在東北待命，等朱儁在西南擊鼓');
        m.line('孫堅', '朱將軍在西南擂鼓，賊眾必定往那邊去。我們等鼓聲一響，就從北牆先登！');
        m.after(5, () => m.i === 0 && m.line('提示', `孫堅現在 ${me.lv} 級，四招都學得到了。先把技能點配好。`));
      },
      tick(m) { return m.t > 12; },
    },
    { // 2. 鼓響：東北守軍一批批調去西南；到北牆架雲梯
      enter(m, w) {
        m.done('drum');
        m.vars.drumT = w.t;
        m.big('西南鼓聲大作！');
        m.card('儁因鳴鼓攻其西南，賊悉衆赴之。', '《後漢書·朱儁傳》');
        m.after(2, () => m.line('孫堅', '賊兵往西南去了！到北牆下，架雲梯！'));
        m.after(9, () => m.line('提示', '城頭的箭與熱油落下前，地上會先出現紅圈，看到就閃開。架梯、攀城時站著不動才不會中斷。'));
        m.mark('ladder', LADDER[0], LADDER[1], '架雲梯');
        m.obj('left', '東北的守軍');
        m.obj('ladder', '到北牆下架起雲梯');
        m.vars.ladder = 0; // 0 還沒架、1 架好了
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.archT = (V.archT || 0) - dt;
        // 梯子架好之後：城頭的弓手全盯著梯子。梯下附近有赤幘替身就射替身，不然射攀城的人
        const decoy = w.units.find((u) => u.alive && u.image && u.owner === me && SG.gd(u.x, u.y, LADDER[0], LADDER[1]) < 600);
        if (V.ladder && (decoy || SG.gd(me.x, me.y, LADDER[0], LADDER[1]) < 360)) {
          V.focusT = (V.focusT || 0) - dt;
          if (V.focusT <= 0) {
            const tg = decoy || (me.st.invis > 0 ? null : me);
            V.focusT = 0.7;
            if (tg) m.strike(tg.x + (SG.rand() - 0.5) * 40, tg.y + (SG.rand() - 0.5) * 30, 90, 0.8, 50, 0);
          }
          if (!V.hinted) { V.hinted = true; m.line('孫堅', '城頭的弓手全盯著梯子……'); m.after(2, () => m.line('提示', '站著攀城會被射下來。先在梯子旁邊放 W 赤幘，替身會引開箭，再隱身走到梯下攀城。')); }
          V.archT = 2.2;
        }
        // 城頭的箭雨：在北牆外靠近城牆時，每 2.2 秒往你腳下射一陣；熱油只往梯腳倒
        if (V.archT <= 0 && me.alive && Math.abs(me.y - (CITY.y - CITY.hh)) < 520 && me.x > CITY.x - CITY.hw - 200 && me.x < CITY.x + CITY.hw + 200) {
          V.archT = 2.2;
          m.strike(me.x + (SG.rand() - 0.5) * 420, me.y + (SG.rand() - 0.5) * 240, 110, 1.2, 45, 0);
          if (SG.rand() < 0.25 && SG.gd(me.x, me.y, LADDER[0], LADDER[1]) < 300) m.strike(LADDER[0], LADDER[1] + 20, 150, 2, 120, 0, { smoke: true, col: '#ff9a3a' }); // 熱油：只倒在梯腳，要躲開（會打斷架梯）
        }
        // 雲梯：梯腳要有兩個人守著，不然城上會推倒
        if (V.ladder) {
          V.pushT = (V.pushT || 6) - dt;
          if (V.pushT <= 0) {
            V.pushT = 6;
            const guard = m.alive(V.men).filter((u) => SG.gd(u.x, u.y, LADDER[0], LADDER[1]) < 260).length;
            if (guard < 2) { V.ladder = 0; V.fell = true; m.big('雲梯被推倒了！'); m.line('孫堅', '梯腳沒人守！讓弟兄們守住梯腳，再架一次！'); m.get('ladder').done = false; }
          }
        }
        if (!V.ladder) m.chanAt(me, 'ladder', LADDER[0], LADDER[1], 140, 4, '架雲梯', () => { V.ladder = 1; V.pushT = 6; m.done('ladder'); m.line('孫堅', '梯子架好了！守住梯腳，我先上！'); }, { hurt: false });
        else m.chanAt(me, 'climb', LADDER[0], LADDER[1], 140, 2, '攀城', () => { V.climbed = true; }, { fail: (why) => { if (why === '中斷') { V.shotDown = true; m.line('孫堅', '（被箭射了下來）……再來！'); } } });
        return !!V.climbed;
      },
    },
    { // 3. 先登：東北門打開，漢軍蟻附而入
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.climbT = w.t - V.drumT;
        me.x = INSIDE[0]; me.y = INSIDE[1];
        m.unmark('ladder'); m.drop('left');
        w.fx({ k: 'puff', x: me.x, y: me.y });
        m.big('先登！');
        m.card('堅身當一面，登城先入，衆乃蟻附。', '《孫堅傳》');
        m.ungate('ne');
        for (const u of m.alive(V.men)) { const p = SG.MAP.nearestFree(INSIDE[0] - 60, INSIDE[1] + 40); u.x = p[0] + (SG.rand() - 0.5) * 120; u.y = p[1] + (SG.rand() - 0.5) * 60; }
        V.han = [];
        for (let i = 0; i < 16; i++) { const u = m.recruit(GATES.ne[0] - 90 + (i % 6) * 36, GATES.ne[1] - 120 - Math.floor(i / 6) * 50, '漢軍'); u.spec = HAN; u.hp = u.maxHp = 520; u.atk = 24; m.join(u, me); V.han.push(u); } // 漢軍蟻附：人多
        m.after(1.5, () => m.line('漢軍', '孫司馬先登了！殺進去！'));
        // 有人先登，城頭大亂：東北還在的守軍一半潰逃
        const stay = V.ne.filter((u) => u.alive && !u.away);
        rout(m, w, stay.slice(0, Math.ceil(stay.length / 2)), [CITY.x - 600, CITY.y + 600]);
        const hz = boss(w, PEOPLE.hanzhong, CITY.x - 100, CITY.y + 100, { hp: 3200, atk: 46, armor: 6, name: '韓忠' });
        V.boss = hz;
        V.guard = m.camp(CITY.x - 100, CITY.y + 100, [['huangjin', 5]], 260);
        m.mark('boss', hz.x, hz.y, '韓忠', false, hz);
        m.obj('boss', '擊退守將韓忠');
      },
      tick(m, w) {
        const b = m.vars.boss;
        if (b.hp < b.maxHp * 0.3 || !b.alive) {
          m.unmark('boss'); m.done('boss');
          if (b.alive) { b.untargetable = true; b.home = [CITY.x - 900, CITY.y + 500]; b.target = null; m.line('韓忠', '守不住了……退保小城！'); }
          rout(m, w, m.vars.guard.concat(m.vars.ne, m.vars.sw), [CITY.x - 900, CITY.y + 500]);
          m.card('韓忠退保小城。', '《後漢書·朱儁傳》');
          m.after(3, () => m.win());
          return true;
        }
        return false;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w, dt) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('孫堅陣亡'); return; }
    if (V.drumT == null) return;
    // 東北的守軍：鼓響後每 3 秒調走一人往西南；佯攻結束後陸續回來
    const t = w.t - V.drumT;
    V.moveT = (V.moveT || 0) - dt;
    if (V.moveT <= 0 && !V.climbed) {
      V.moveT = 3;
      if (t < FEINT) { const u = V.ne.find((u) => u.alive && !u.away && !u.target); if (u) { u.away = true; u.home = [SW_POST[0] + (SG.rand() - 0.5) * 300, SW_POST[1]]; } }
      else { const u = V.ne.find((u) => u.alive && u.away); if (u) { u.away = false; u.home = [NE_POST[0] + (SG.rand() - 0.5) * 400, NE_POST[1]]; if (!V.back) { V.back = true; m.line('孫堅', '西南的鼓停了……賊兵要回來了，快！'); } } }
    }
    const o = m.get('left');
    if (o) { const n = V.ne.filter((u) => u.alive && !u.away).length; o.text = t < FEINT ? `東北的守軍還剩 ${n} 人（佯攻還有 ${Math.ceil(FEINT - t)} 秒）` : `佯攻結束，守軍回來了（東北 ${n} 人）`; }
  },
};
